<template>
  <v-card
    class="pa-6 d-flex"
    style="
      flex-direction: column;
      gap: 20px;
      background: var(--v-background_light-base);
      width: 100%;
    "
    flat
    rounded="xl"
  >
    <div class="d-flex">
      <div class="title-1 font-weight-bold onSurface_dark--text">
        {{ $t("mypage.companyInfo") }}
      </div>
      <v-spacer />
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon size="20" v-bind="attrs" v-on="on">
            mdi-help-circle-outline
          </v-icon>
        </template>
        <span v-text="$t('mypage.companyInfo_help')" />
      </v-tooltip>
    </div>
    <div
      class="d-flex"
      style="gap: 12px; flex-wrap: wrap; justify-content: space-between"
    >
      <div
        v-for="c in companyInfo"
        :key="c.key"
        style="width: inherit"
        :style="
          $vuetify.breakpoint.lgAndUp ? 'flex: 1 1 47%' : 'flex: 1 1 100%'
        "
        class="d-flex pa-3 content_box"
      >
        <div class="d-flex my-auto" style="gap: 12px">
          <v-avatar size="36" color="primary">
            <v-icon class="ma-auto" color="white_light_global">
              {{ c.icon }}
            </v-icon>
          </v-avatar>
          <div class="d-flex-column my-auto">
            <div class="subtitle-2 font-weight-bold onSurface_light--text">
              {{ $t("mypage.company." + c.value) }}
            </div>
            <div
              class="subtitle-1 font-weight-bold onSurface_dark--text"
              style="white-space: nowrap"
            >
              {{
                userData.companyInfo
                  ? userData.companyInfo[c.value] || "-"
                  : "-"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "MyPage-CompanyCard",
  props: { userData: Object },
  computed: {},
  data() {
    return {
      companyInfo: [
        {
          key: "상호",
          value: "companyName",
          icon: "mdi-domain",
        },
        {
          key: "대표자",
          value: "cheifName",
          icon: "mdi-account-tie",
        },
        {
          key: "회사 메일",
          value: "email",
          icon: "mdi-briefcase-variant",
        },
        {
          key: "사업자번호",
          value: "companyId",
          icon: "mdi-ticket-percent",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style>
.content_box {
  outline: 1px solid var(--v-background_normal-base);
  border-radius: 12px;
  background-color: var(--v-primary_light-base);
  height: 64px;
}
</style>
